import request from '@/utils/request'

// 按获取权限1
export function getByUname() {
  return request({
    url: '/service/api/roles/get-by-uname',
    method: 'POST'
  })
}




// WEBPACK FOOTER //
// ./src/api/getByUname.js